import React, { useEffect, useState } from "react";
import "./AccountSetting.css";
import Breadcrumb_comp from "../Common-Component/Breadcrumb_comp/Breadcrumb_comp";
import { faPenToSquare } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useForm } from "react-hook-form";
import { Form } from "react-bootstrap";
import Black_Btn from "../Common-Component/Common_Btn/Black_Btn/Black_Btn";
import { useDispatch, useSelector } from "react-redux";
import { myaccountForm, myaccountUpdate, profilephotoUpdate } from "../../features/my_account/Slice";
import SuccessModal from "../Common-Component/Common_Modal/SuccessModal/SuccessModal";

const AccountSetting = () => {

  const myaccount = useSelector((state) => state.myaccount.addMyaccount);
  const dispatch = useDispatch();
 

  useEffect(() => {
           dispatch(myaccountForm());
         }, [dispatch]);

  const breadcrumbData = [
    { name: "Home", link: "/home" },
    { name: "ACCOUNT SETTINGS" }, // No link for the last item (active)
  ];


  const {
    control,
    register,
    handleSubmit,
    getValues,
    setValue,
    setError,
    clearErrors,
    formState: { errors },
    reset,
    trigger,
  } = useForm();




 const [showSuccessModal, setShowSuccessModal] = useState(false);
  const onSubmit = async (data) => {
  const formData = new FormData();
  formData.append("name", data.name);
  formData.append("email", data.email);
  formData.append("contact_no", data.contact_no);
  formData.append("password", data.password);

  if (data.image) {
    formData.append("profile_photo", data.image); // Ensure field name matches backend
  }

  try {
    const res = await dispatch(myaccountUpdate(formData));
   
    
    // if (data.image) {
    //   // Dispatch profile photo update separately
    //   const photoFormData = new FormData();
    //   photoFormData.append("profile_photo", data.image);
    //   await dispatch(profilephotoUpdate(photoFormData));
    //  
setShowSuccessModal(true);
    reset(); // Reset form on success
  } catch (error) {
    
    setError("password", {
      type: "manual",
      message: error || "An error occurred",
    });
  }
};

      
  useEffect(() => {
    reset(myaccount);
  }, [myaccount]);
  const [imagePreview, setImagePreview] = useState(null);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      // Set the file in the form using setValue
      setValue("image", file);

      // Set the image preview
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result); // Set the preview image
      };
      reader.readAsDataURL(file);
    }
  };

  return (
    <section className="AccountSetting">
      <div className="custom_container">
        <div className="breadcrump_holder">
          <div className="Breadcrumb_div">
            <Breadcrumb_comp data={breadcrumbData} />
          </div>
        </div>

        <div className="account_setting_main_div">
          <div className="heading_div">
            <div className="title_div">
              <p className="title">Account Settings</p>
            </div>

            <div className="edit_icon_div">
              <FontAwesomeIcon icon={faPenToSquare} className="edit" />
            </div>
          </div>

          <div className="profile_pic_section">
            <div className="profile-img-holder">
              <div className="img_holder">
                {imagePreview ? (
                  <div className="image_preview_container">
                    <img
                      src={imagePreview}
                      alt="Preview"
                      className="image_preview"
                    />
                  </div>
                ) : (
                  <div className="image_preview_container">
                    <img
                      src={process.env.REACT_APP_IMG_URL + myaccount?.profile_photo}
                      alt="Preview"
                      className="image_preview"
                    />
                  </div>
                )}
              </div>
              <div className="file_input_holder">
                <input
                  type="file"
                  className="file_input"
                  id="fileUpload"
                  accept="image/*"
                  onChange={handleImageChange}
                />
                <label htmlFor="fileUpload" className="custom_file_label">
                  +
                </label>
              </div>
            </div>
          </div>

          <div className="form_div">
            <Form onSubmit={handleSubmit(onSubmit)}>
              <div className="address_form">
                <Form.Group className="form-group">
                  <Form.Control
                    type="text"
                    name="name"
                    placeholder="Enter Full Name"
                    {...register("name", {
                      required: "Name is required",
                    })}
                  />
                  {errors?.name && (
                    <span className="invalid-feedback d-block">
                      {errors.name.message}
                    </span>
                  )}
                </Form.Group>

                <Form.Group className="form-group">
                  <Form.Control
                    type="text"
                    name="email"
                    placeholder="Enter Email"
                    {...register("email", {
                      required: "email is required",
                    })}
                  />
                  {errors?.email && (
                    <span className="invalid-feedback d-block">
                      {errors.email.message}
                    </span>
                  )}
                </Form.Group>

                <Form.Group className="form-group">
                  <Form.Control
                    type="text"
                    name="contact_no"
                    placeholder="Enter Mobile Number"
                    {...register("contact_no", {
                      required: "contact_no is required",
                    })}
                  />
                  {errors?.contact_no && (
                    <span className="invalid-feedback d-block">
                      {errors.contact_no.message}
                    </span>
                  )}
                </Form.Group>

                <Form.Group className="form-group">
                  <Form.Control
                    type="text"
                    name="password"
                    placeholder="Password"
                    {...register("password", {
                      // required: "password is required",
                    })}
                  />
                  {errors?.password && (
                    <span className="invalid-feedback d-block">
                      {errors.password.message}
                    </span>
                  )}
                </Form.Group>
              </div>

              <div className="submit_btn">
                <Black_Btn btnText={"Submit"}  type={"submit"}/>
              </div>
            </Form>
          </div>
        </div>
      </div>
      <SuccessModal
        show={showSuccessModal}
        onHide={() => setShowSuccessModal(false)}
        successText="Profile Update Successfully!"
      />
    </section>

    
  );
};

export default AccountSetting;
